import 'Utils/polyfills';
import './index.css';

import App from './App';
import { COGNITO_POOL_ID, COGNITO_CLIENT_ID, COGNITO_OAUTH_DOMAIN } from './config';
import { QueryClientProvider } from '@tanstack/react-query';
import { Amplify } from 'aws-amplify';
import 'aws-amplify/auth/enable-oauth-listener';
import queryClient from 'Utils/queryClient';
import * as errorMonitoring from 'Utils/errorMonitoring';
import { createRoot } from 'react-dom/client';
import './i18n';

Amplify.configure({
    Auth: {
        Cognito: {
            userPoolId: COGNITO_POOL_ID,
            userPoolClientId: COGNITO_CLIENT_ID,
            loginWith: {
                oauth: {
                    domain: COGNITO_OAUTH_DOMAIN,
                    scopes: ['openid', 'email', 'profile'],
                    redirectSignIn: [`${window.location.origin}/`],
                    redirectSignOut: [`${window.location.origin}/iniciar-sesion`],
                    responseType: 'code',
                    providers: ['Google'],
                },
            },
        },
    },
});

errorMonitoring.init();

if (import.meta.env.VITE_MSW === 'true') {
    const { startWorker } = await import('./mocks/browser');
    await startWorker();
}

const root = createRoot(document.getElementById('root'));
root.render(
    <QueryClientProvider client={queryClient}>
        <App />
    </QueryClientProvider>,
);
